'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var style = {"leftMenuMultiLevel":"Menu-module_leftMenuMultiLevel__1uLX2","hover":"Menu-module_hover__9cGs1","hasSub":"Menu-module_hasSub__MIIin","hasCurrentSub":"Menu-module_hasCurrentSub__eDljY","current":"Menu-module_current__6Kx-J"};

exports["default"] = style;
